export const GENERATE_NUMBER_OPTIONS = [10, 15, 20, 30] as const;

export type GenerateNumberOption = (typeof GENERATE_NUMBER_OPTIONS)[number];

/**
 * UI 의 난이도 선택값. '0'..'4' 는 단일 난이도, 'mixed' 는 혼합 난이도 sentinel.
 * 혼합이 선택되면 서버가 그룹별 병렬 생성으로 처리한다.
 * dropdown 노출 순서 = 배열 순서. mixed 를 가장 위에 노출하여 사용자가
 * "문제 유형 섞기" 와 동일한 위치에서 발견하도록 한다.
 */
export const QUIZ_LEVEL_OPTIONS = ['mixed', '0', '1', '2', '3', '4'] as const;

export type QuizLevelOption = (typeof QUIZ_LEVEL_OPTIONS)[number];

/** 혼합 난이도 sentinel. 서버 wire 값 ("mixed") 과 동일하게 유지. */
export const MIXED_DIFFICULTY_VALUE = 'mixed' as const;

/**
 * 퀴즈 generation 요청에 실리는 ``difficulty`` 필드 값의 도메인 타입.
 * 단일 난이도(int 0~4) 또는 혼합 sentinel('mixed').
 * 명명 규칙: 같은 파일(api/ai/type.ts)의 ``ApiGenerationMode`` / ``ApiUiCohort``
 * 와 동일한 ``Api`` 접두사 패턴 — wire 표면 타입임을 명시.
 */
export type ApiQuizDifficulty = number | typeof MIXED_DIFFICULTY_VALUE;

/** UI ``QuizLevelOption`` → wire ``ApiQuizDifficulty`` 변환. */
export function quizLevelToApiQuizDifficulty(
  level: QuizLevelOption,
): ApiQuizDifficulty {
  if (level === MIXED_DIFFICULTY_VALUE) return MIXED_DIFFICULTY_VALUE;
  return parseInt(level, 10);
}
